import { createAuthStore } from '@onereach/auth-ui-module';
import Auth from '@/api/Auth';
export const useAuthStore = createAuthStore(Auth);
export default useAuthStore;
